<template>
    
</template>

<script>
    export default {
        name: "ActionTriggerComponent",
        data () {
            return {
                componentType: "action-trigger",
                rendersWithVue: true
            }
        },
        computed: {
            actionTriggerType () {
                return this.myDataNodeAttribute;
            },
            myActionTriggerComponentData () {
                return this.getActionTriggerComponentsData.find( data => data.template === this.actionTriggerType) || {};
            },
            contextWrapper () {
                return this.hasContext("context-wrapper") ? this.findNodeState(this.hasContext("context-wrapper")[0].id) : null;
            },
            getPrimaryNodeState () {
                return this.contextWrapper && this.contextWrapper.getPrimaryNodeState ? this.contextWrapper.getPrimaryNodeState : null ;
            },
            getActionTriggerComponentsData () {
                return this.getPrimaryNodeState && this.getPrimaryNodeState.getActionTriggerComponentsData ? this.getPrimaryNodeState.getActionTriggerComponentsData : [];
            },
        },
        methods: {
            handleActionTrigger (componentName) {
                this.getPrimaryNodeState.handleActionTrigger(componentName);
            }
        }
    }
</script>

